module.exports = __webpack_public_path__ + "static/media/browser-hero-image.2a448949.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/browser-hero-image.svg
// module id = 44
// module chunks = 0